import { Transcode } from '../models/transcode.model';

export const TYPE_DOC_DANNI_VEICOLO = 'DANNI_VEICOLO';
export const TYPE_DOC_DOCUMENTO_TESTIMONE = 'DOCUMENTO_TESTIMONE';
export const TYPE_DOC_CID = 'CID';
export const TYPE_DOC_RIEPILOGO_PDF = 'RIEPILOGO_PDF';

export const buildVehicleDamageFileName = (plate: string, fileName: string) =>
  `${plate}_${fileName}`;

export const extractPlateFromVehicleDamageFilename = (
  originalName?: string | null
): string | undefined => {
  if (!originalName) return undefined;
  const separatorIndex = originalName.indexOf('_');
  return separatorIndex > 0 ? originalName.slice(0, separatorIndex) : undefined;
};

export const findTypeDocByDescription = (
  transcodes: Transcode[],
  description: string
): Transcode | undefined => transcodes.find((item) => item.description === description);

export const getTypeDocIdByDescription = (
  transcodes: Transcode[],
  description: string
): number | undefined => findTypeDocByDescription(transcodes, description)?.id;
